import { CriticalityLevel, ChangeType } from './change';
export function schemaQueryTypeChanged(oldSchema, newSchema) {
    const oldName = (oldSchema.getQueryType() || {}).name || 'unknown';
    const newName = (newSchema.getQueryType() || {}).name || 'unknown';
    return {
        criticality: {
            level: CriticalityLevel.Breaking,
        },
        type: ChangeType.SchemaQueryTypeChanged,
        message: `Schema query root has changed from '${oldName}' to '${newName}'`,
    };
}
export function schemaMutationTypeChanged(oldSchema, newSchema) {
    const oldName = (oldSchema.getMutationType() || {}).name || 'unknown';
    const newName = (newSchema.getMutationType() || {}).name || 'unknown';
    return {
        criticality: {
            level: CriticalityLevel.Breaking,
        },
        type: ChangeType.SchemaMutationTypeChanged,
        message: `Schema mutation root has changed from '${oldName}' to '${newName}'`,
    };
}
export function schemaSubscriptionTypeChanged(oldSchema, newSchema) {
    const oldName = (oldSchema.getSubscriptionType() || {}).name || 'unknown';
    const newName = (newSchema.getSubscriptionType() || {}).name || 'unknown';
    return {
        criticality: {
            level: CriticalityLevel.Breaking,
        },
        type: ChangeType.SchemaSubscriptionTypeChanged,
        message: `Schema subscription root has changed from '${oldName}' to '${newName}'`,
    };
}
//# sourceMappingURL=schema.js.map